import { getData, postData } from "./apiService";
import { uploadFileToS3 } from "./fileService";

// Upload logo to S3
export const uploadLogo = async (eventId: string, file: File) => {
  try {
    // 1. Get the pre-signed URL for the file upload
    const { uploadUrl } = await getEventLogoUploadUrl(eventId, file);
    // 2. Upload the file to S3 using the pre-signed URL
    const success = await uploadFileToS3(uploadUrl, file);

    if (success) {
      console.log('Logo uploaded successfully!');
      // Optionally, notify user about success or perform other UI actions
    } else {
      console.error('Failed to upload logo');
      // Notify user of upload failure (could be a user-friendly message)
    }
  } catch (error) {
    console.error('Error uploading logo:', error);
    // Provide feedback to the user (e.g., show error message in UI)
  }
};

// Get pre-signed URL for uploading logo
const getEventLogoUploadUrl = async (eventId: string, file: File) => {
  try {
    const response = await postData(`/events/${eventId}/logo/upload-url`, {
      file_name: file.name,
      file_type: file.type,
    });

    return response.data as {
      uploadUrl: string;
      s3_key: string;
    };
  } catch (error) {
    console.error('Error fetching logo upload URL:', error);
    throw error;
  }
};

// Get pre-signed URL for downloading the logo
export const getLogoDownloadUrl = async (eventId: string, fileName: string): Promise<string> => {
  try {
    // Request the download URL from the backend
    const response = await getData(`/events/${eventId}/logo/${fileName}`);
    
    // Return the download URL
    return response.data.downloadUrl;
  } catch (error) {
    console.error('Error fetching logo download URL:', error);
    throw error;
  }
};
